// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../../font/Roboto-Regular.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("../../../font/Roboto-Light.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("../../../font/CenturyGothic.ttf", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@font-face {
  font-family: "Roboto-Regular";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_0___}) format("truetype");
}
@font-face {
  font-family: "Roboto-Light";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_1___}) format("truetype");
}
@font-face {
  font-family: "Century Gothic";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_2___}) format("truetype");
}
@keyframes scaleAnimation {
  0% {
    opacity: 1;
  }
  50% {
    opacity: 0;
    transform: scale(1.3);
  }
  70% {
    transform: scale(1);
  }
  100% {
    opacity: 1;
  }
}
.container_about_job .about_webcam_job {
  margin: 0 auto 150px auto;
  max-width: 1200px;
  display: grid;
  grid-template-columns: 1fr 1fr;
}
@media screen and (max-width: 991px) {
  .container_about_job .about_webcam_job {
    grid-template-columns: 1fr;
    padding: 0 50px;
    justify-content: center;
    max-width: 720px;
  }
}
@media screen and (max-width: 380px) {
  .container_about_job .about_webcam_job {
    grid-template-columns: 1fr;
    padding: 0 50px;
    justify-content: center;
    max-width: 370px;
  }
}
.container_about_job .about_webcam_job .animation_block {
  margin: 0;
  padding: 0;
}
.container_about_job .about_webcam_job .animation_block .slick-slider {
  margin: 0 auto;
  max-width: 490px;
}
@media screen and (max-width: 480px) {
  .container_about_job .about_webcam_job .animation_block .slick-slider {
    max-width: 380px;
  }
}
@media screen and (max-width: 380px) {
  .container_about_job .about_webcam_job .animation_block .slick-slider {
    max-width: 340px;
  }
}
.container_about_job .about_webcam_job .animation_block .slick-slider img {
  width: 100%;
  height: 100%;
}
@media screen and (max-width: 480px) {
  .container_about_job .about_webcam_job .descriptionJob {
    margin: 0 auto;
    max-width: 380px;
  }
}
@media screen and (max-width: 480px) {
  .container_about_job .about_webcam_job .descriptionJob .special_text {
    margin: 0 auto;
    max-width: 380px;
  }
}
.container_about_job .about_webcam_job .descriptionJob .special_text h3 {
  color: #323232;
  font-family: "Century Gothic";
  font-weight: 700;
  font-size: 3rem;
  line-height: 4rem;
}
@media screen and (max-width: 380px) {
  .container_about_job .about_webcam_job .descriptionJob .special_text h3 {
    padding: 0 20px;
    font-size: 1.56rem;
    line-height: 1.2em;
  }
}
.container_about_job .about_webcam_job .descriptionJob h4 {
  margin: 30px 0 0 0;
  color: #323232;
  font-family: "Century Gothic";
  font-weight: 300;
  font-size: 1.8rem;
  line-height: 0.5rem;
}
@media screen and (max-width: 480px) {
  .container_about_job .about_webcam_job .descriptionJob h4 {
    line-height: 2rem;
  }
}
@media screen and (max-width: 380px) {
  .container_about_job .about_webcam_job .descriptionJob h4 {
    padding: 0 20px;
    font-size: 1.4rem;
    line-height: 1.2em;
  }
}
.container_about_job .about_webcam_job .descriptionJob p {
  color: #818181;
  font-family: "Roboto-Light";
  font-size: 17px;
  line-height: 1.4rem;
}
.container_about_job .container_who_need .container_text_who_need {
  margin: 0 auto;
  max-width: 800px;
}
.container_about_job .container_who_need .container_text_who_need h3 {
  text-align: center;
  color: #323232;
  font-family: "Century Gothic";
  font-weight: 300;
  font-size: 2.4rem;
  line-height: 3rem;
}
@media screen and (max-width: 380px) {
  .container_about_job .container_who_need .container_text_who_need h3 {
    padding: 0 20px;
    font-size: 1.56rem;
    line-height: 1.2em;
  }
}
.container_about_job .container_who_need .container_text_who_need p {
  text-align: center;
  font-family: "Roboto-Light";
  font-size: 17px;
  font-weight: 300;
  list-style: 1.5rem;
  color: #818181;
}
.container_about_job .container_who_need .items_who_need {
  margin: 0 auto;
  max-width: 800px;
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  justify-content: center;
}
@media screen and (max-width: 991px) {
  .container_about_job .container_who_need .items_who_need {
    grid-template-columns: repeat(1, 1fr);
  }
}
.container_about_job .container_who_need .items_who_need .item_who_need {
  display: grid;
  justify-content: center;
}
.container_about_job .container_who_need .items_who_need .item_who_need img {
  margin: 0 auto;
  max-width: 100px;
}
.container_about_job .container_who_need .items_who_need .item_who_need img:hover {
  animation: 1s scaleAnimation ease-out;
}
.container_about_job .container_who_need .items_who_need .item_who_need h3 {
  text-align: center;
  font-family: "Century Gothic";
  color: #323232;
  font-size: 17px;
  font-weight: 600;
  line-height: 1.1rem;
}
.container_about_job .container_who_need .items_who_need .item_who_need .teaser_content {
  color: #818181;
  font-family: "Roboto-Light";
  font-size: 17px;
}
.container_about_job .container_who_need .container_button {
  margin: 40px 0;
  text-align: center;
}
.container_about_job .psyhotest {
  background-color: #f4f4f4;
}
.container_about_job .psyhotest .wrapper_psyhotest {
  margin: 0 auto;
  max-width: 1200px;
  padding: 30px;
}
.container_about_job .psyhotest .wrapper_psyhotest .special_heading {
  color: #323232;
  font-family: "Century Gothic";
  font-size: 2.4rem;
  font-weight: 600;
  line-height: 3rem;
}
.container_about_job .psyhotest .wrapper_psyhotest .special_heading h2 {
  text-align: center;
}
@media screen and (max-width: 380px) {
  .container_about_job .psyhotest .wrapper_psyhotest .special_heading h2 {
    padding: 0 20px;
    font-size: 1.56rem;
    line-height: 1.2em;
  }
}
.container_about_job .about_useful {
  margin: 0 auto;
  max-width: 1200px;
}
.container_about_job .about_useful .about_useful_title {
  text-align: center;
}
@media screen and (max-width: 991px) {
  .container_about_job .about_useful .about_useful_title {
    max-width: 720px;
    margin: 0 auto;
  }
}
.container_about_job .about_useful .about_useful_title h3 {
  font-family: "Century Gothic";
  color: #323232;
  font-size: 3rem;
  font-weight: 300;
  line-height: 4rem;
}
@media screen and (max-width: 380px) {
  .container_about_job .about_useful .about_useful_title h3 {
    padding: 0 20px;
    font-size: 1.56rem;
    line-height: 1.2em;
  }
}
.container_about_job .about_useful .about_useful_title p {
  font-family: "Roboto-Light";
  font-size: 17px;
  font-weight: 300;
  line-height: 1.5rem;
  color: #818181;
}
.container_about_job .about_useful .content_about_usrful {
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
}
@media screen and (max-width: 991px) {
  .container_about_job .about_useful .content_about_usrful {
    margin: 0 auto;
    max-width: 720px;
    flex-direction: column;
  }
}
@media screen and (max-width: 991px) {
  .container_about_job .about_useful .content_about_usrful .about_job_image_usrful {
    text-align: center;
  }
}
@media screen and (max-width: 480px) {
  .container_about_job .about_useful .content_about_usrful .about_job_image_usrful img {
    width: 100%;
    height: auto;
  }
}
.container_about_job .about_useful .content_about_usrful .list_reasons .item_reason {
  margin-bottom: 20px;
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
}
.container_about_job .about_useful .content_about_usrful .list_reasons .item_reason .num {
  display: flex;
  justify-content: center;
  align-items: center;
}
.container_about_job .about_useful .content_about_usrful .list_reasons .item_reason .num span {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 80px;
  height: 80px;
  border-radius: 50%;
  font-family: "Roboto-Regular";
  font-size: 1.9rem;
  font-weight: 700;
}
.container_about_job .about_useful .content_about_usrful .list_reasons .item_reason .item_reason_text {
  padding: 0 20px;
  text-align: left;
  font-family: "Roboto-Light";
  font-size: 17px;
  font-weight: 300;
  line-height: 1.5rem;
  color: #818181;
}
.container_about_job .about_useful .content_about_usrful .list_reasons .item_reason .item_reason_text strong {
  font-weight: 700;
}
.container_about_job .about_useful .content_about_usrful .list_reasons .item_reason:nth-child(odd) .num span {
  background-color: #91b61b;
}
.container_about_job .about_useful .content_about_usrful .list_reasons .item_reason:nth-child(even) .num span {
  background-color: #284722;
}`, "",{"version":3,"sources":["webpack://./styles/fonts.scss","webpack://./src/pages/AboutJob/AboutJob.scss","webpack://./styles/animation.scss"],"names":[],"mappings":"AAAA;EACI,6BAAA;EACA,+DAAA;ACCJ;ADEA;EACI,2BAAA;EACA,+DAAA;ACAJ;ADGA;EACI,6BAAA;EACA,+DAAA;ACDJ;ACXA;EACI;IACE,UAAA;EDaJ;ECVE;IACE,UAAA;IACA,qBAAA;EDYJ;ECTE;IACA,mBAAA;EDWF;ECRE;IACE,UAAA;EDUJ;AACF;AArBI;EACI,yBAAA;EACA,iBAAA;EACA,aAAA;EACA,8BAAA;AAuBR;AApBQ;EAPJ;IAQQ,0BAAA;IACA,eAAA;IACA,uBAAA;IACA,gBAAA;EAuBV;AACF;AArBQ;EAdJ;IAeQ,0BAAA;IACA,eAAA;IACA,uBAAA;IACA,gBAAA;EAwBV;AACF;AApBQ;EACI,SAAA;EACA,UAAA;AAsBZ;AApBY;EACI,cAAA;EACA,gBAAA;AAsBhB;AAnBgB;EALJ;IAMQ,gBAAA;EAsBlB;AACF;AApBgB;EATJ;IAUQ,gBAAA;EAuBlB;AACF;AArBgB;EACI,WAAA;EACA,YAAA;AAuBpB;AAhBY;EAFJ;IAGQ,cAAA;IACA,gBAAA;EAmBd;AACF;AAdgB;EAFJ;IAGQ,cAAA;IACA,gBAAA;EAiBlB;AACF;AAfgB;EACI,cAAA;EACA,6BAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;AAiBpB;AAfoB;EAPJ;IAQQ,eAAA;IACA,kBAAA;IACA,kBAAA;EAkBtB;AACF;AAdY;EACI,kBAAA;EACA,cAAA;EACA,6BAAA;EACA,gBAAA;EACA,iBAAA;EACA,mBAAA;AAgBhB;AAdgB;EARJ;IASQ,iBAAA;EAiBlB;AACF;AAfgB;EAZJ;IAaQ,eAAA;IACA,iBAAA;IACA,kBAAA;EAkBlB;AACF;AAfY;EACI,cAAA;EACA,2BAAA;EACA,eAAA;EACA,mBAAA;AAiBhB;AAVQ;EACI,cAAA;EACA,gBAAA;AAYZ;AAVY;EACI,kBAAA;EACA,cAAA;EACA,6BAAA;EACA,gBAAA;EACA,iBAAA;EACA,iBAAA;AAYhB;AAVgB;EARJ;IASQ,eAAA;IACA,kBAAA;IACA,kBAAA;EAalB;AACF;AAVY;EACI,kBAAA;EACA,2BAAA;EACA,eAAA;EACA,gBAAA;EACA,kBAAA;EACA,cAAA;AAYhB;AAPQ;EACI,cAAA;EACA,gBAAA;EACA,aAAA;EACA,qCAAA;EACA,uBAAA;AASZ;AAPY;EAPJ;IAQQ,qCAAA;EAUd;AACF;AARY;EACI,aAAA;EACA,uBAAA;AAUhB;AARgB;EACI,cAAA;EACA,gBAAA;AAUpB;AAPgB;EACI,qCAAA;AASpB;AANgB;EACI,kBAAA;EACA,6BAAA;EACA,cAAA;EACA,eAAA;EACA,gBAAA;EACA,mBAAA;AAQpB;AALgB;EACI,cAAA;EACA,2BAAA;EACA,eAAA;AAOpB;AAFQ;EACI,cAAA;EACA,kBAAA;AAIZ;AAAI;EACI,yBAAA;AAER;AAAQ;EACI,cAAA;EACA,iBAAA;EACA,aAAA;AAEZ;AAAY;EACI,cAAA;EACA,6BAAA;EACA,iBAAA;EACA,gBAAA;EACA,iBAAA;AAEhB;AAAgB;EACI,kBAAA;AAEpB;AAAoB;EAHJ;IAIQ,eAAA;IACA,kBAAA;IACA,kBAAA;EAGtB;AACF;AAGI;EACI,cAAA;EACA,iBAAA;AADR;AAGQ;EACI,kBAAA;AADZ;AAGY;EAHJ;IAIQ,gBAAA;IACA,cAAA;EAAd;AACF;AAEY;EACI,6BAAA;EACA,cAAA;EACA,eAAA;EACA,gBAAA;EACA,iBAAA;AAAhB;AAEgB;EAPJ;IAQQ,eAAA;IACA,kBAAA;IACA,kBAAA;EAClB;AACF;AAEY;EACI,2BAAA;EACA,eAAA;EACA,gBAAA;EACA,mBAAA;EACA,cAAA;AAAhB;AAKQ;EACI,aAAA;EACA,mBAAA;EACA,iBAAA;AAHZ;AAKY;EALJ;IAMQ,cAAA;IACA,gBAAA;IACA,sBAAA;EAFd;AACF;AAKgB;EADJ;IAEQ,kBAAA;EAFlB;AACF;AAKoB;EADJ;IAEQ,WAAA;IACA,YAAA;EAFtB;AACF;AAOgB;EACI,mBAAA;EACA,aAAA;EACA,mBAAA;EACA,iBAAA;AALpB;AAOoB;EACI,aAAA;EACA,uBAAA;EACA,mBAAA;AALxB;AAOwB;EACI,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EAEA,6BAAA;EACA,iBAAA;EACA,gBAAA;AAN5B;AAUoB;EACI,eAAA;EACA,gBAAA;EACA,2BAAA;EACA,eAAA;EACA,gBAAA;EACA,mBAAA;EACA,cAAA;AARxB;AAUwB;EACI,gBAAA;AAR5B;AAgBwB;EACI,yBAAA;AAd5B;AAqBwB;EACI,yBAAA;AAnB5B","sourcesContent":["@font-face {\n    font-family: \"Roboto-Regular\"; \n    src: url(\"../font/Roboto-Regular.ttf\") format(\"truetype\");  \n}\n\n@font-face {\n    font-family: \"Roboto-Light\"; \n    src: url(\"../font/Roboto-Light.ttf\") format(\"truetype\");  \n}\n\n@font-face {\n    font-family: \"Century Gothic\"; \n    src: url(\"../font/CenturyGothic.ttf\") format(\"truetype\");  \n}\n\n","@import '../../../styles/fonts.scss';\n@import '../../../styles/animation.scss';\n\n.container_about_job {\n\n    .about_webcam_job {\n        margin: 0 auto 150px auto;\n        max-width: 1200px;\n        display: grid;\n        grid-template-columns: 1fr 1fr;\n        // border: 2px solid red;\n\n        @media screen and (max-width: 991px) {\n            grid-template-columns: 1fr;\n            padding: 0 50px;\n            justify-content: center;\n            max-width: 720px;\n        }\n\n        @media screen and (max-width: 380px) {\n            grid-template-columns: 1fr;\n            padding: 0 50px;\n            justify-content: center;\n            max-width: 370px;\n        }\n\n\n\n        .animation_block {\n            margin: 0;\n            padding: 0;\n\n            .slick-slider {\n                margin: 0 auto;\n                max-width: 490px;\n                // height: 600px;\n\n                @media screen and (max-width: 480px) {\n                    max-width: 380px;\n                }\n\n                @media screen and (max-width: 380px) {\n                    max-width: 340px;\n                }\n\n                img {\n                    width: 100%;\n                    height: 100%;\n                }\n            }\n        }\n\n        .descriptionJob {\n\n            @media screen and (max-width: 480px) {\n                margin: 0 auto;\n                max-width: 380px;\n            }\n\n\n            .special_text {\n\n                @media screen and (max-width: 480px) {\n                    margin: 0 auto;\n                    max-width: 380px;\n                }\n\n                h3 {\n                    color: #323232;\n                    font-family: \"Century Gothic\";\n                    font-weight: 700;\n                    font-size: 3rem;\n                    line-height: 4rem;\n\n                    @media screen and (max-width: 380px) {\n                        padding: 0 20px;\n                        font-size: 1.56rem;\n                        line-height: 1.2em;\n                    }\n                }\n            }\n\n            h4 {\n                margin: 30px 0 0 0;\n                color: #323232;\n                font-family: \"Century Gothic\";\n                font-weight: 300;\n                font-size: 1.8rem;\n                line-height: 0.5rem;\n\n                @media screen and (max-width: 480px) {\n                    line-height: 2rem;\n                }\n\n                @media screen and (max-width: 380px) {\n                    padding: 0 20px;\n                    font-size: 1.4rem;\n                    line-height: 1.2em;\n                }\n            }\n\n            p {\n                color: #818181;\n                font-family: \"Roboto-Light\";\n                font-size: 17px;\n                line-height: 1.4rem;\n            }\n        }\n    }\n\n    .container_who_need {\n\n        .container_text_who_need {\n            margin: 0 auto;\n            max-width: 800px;\n\n            h3 {\n                text-align: center;\n                color: #323232;\n                font-family: \"Century Gothic\";\n                font-weight: 300;\n                font-size: 2.4rem;\n                line-height: 3rem;\n\n                @media screen and (max-width: 380px) {\n                    padding: 0 20px;\n                    font-size: 1.56rem;\n                    line-height: 1.2em;\n                }\n            }\n\n            p {\n                text-align: center;\n                font-family: \"Roboto-Light\";\n                font-size: 17px;\n                font-weight: 300;\n                list-style: 1.5rem;\n                color: #818181;\n            }\n        }\n\n\n        .items_who_need {\n            margin: 0 auto;\n            max-width: 800px;\n            display: grid;\n            grid-template-columns: repeat(3, 1fr);\n            justify-content: center;\n\n            @media screen and (max-width: 991px) {\n                grid-template-columns: repeat(1, 1fr);\n            }\n\n            .item_who_need {\n                display: grid;\n                justify-content: center;\n\n                img {\n                    margin: 0 auto;\n                    max-width: 100px;\n                }\n\n                img:hover {\n                    animation: 1s scaleAnimation ease-out;\n                }\n\n                h3 {\n                    text-align: center;\n                    font-family: \"Century Gothic\";\n                    color: #323232;\n                    font-size: 17px;\n                    font-weight: 600;\n                    line-height: 1.1rem;\n                }\n\n                .teaser_content {\n                    color: #818181;\n                    font-family: \"Roboto-Light\";\n                    font-size: 17px;\n                }\n            }\n        }\n\n        .container_button {\n            margin: 40px 0;\n            text-align: center;\n        }\n    }\n\n    .psyhotest {\n        background-color: #f4f4f4;\n\n        .wrapper_psyhotest {\n            margin: 0 auto;\n            max-width: 1200px;\n            padding: 30px;\n\n            .special_heading {\n                color: #323232;\n                font-family: \"Century Gothic\";\n                font-size: 2.4rem;\n                font-weight: 600;\n                line-height: 3rem;\n\n                h2 {\n                    text-align: center;\n\n                    @media screen and (max-width: 380px) {\n                        padding: 0 20px;\n                        font-size: 1.56rem;\n                        line-height: 1.2em;\n                    }\n                }\n            }\n        }\n    }\n\n    .about_useful {\n        margin: 0 auto;\n        max-width: 1200px;\n\n        .about_useful_title {\n            text-align: center;\n\n            @media screen and (max-width: 991px) {\n                max-width: 720px;\n                margin: 0 auto;\n            }\n\n            h3 {\n                font-family: \"Century Gothic\";\n                color: #323232;\n                font-size: 3rem;\n                font-weight: 300;\n                line-height: 4rem;\n\n                @media screen and (max-width: 380px) {\n                    padding: 0 20px;\n                    font-size: 1.56rem;\n                    line-height: 1.2em;\n                }\n            }\n\n            p {\n                font-family: \"Roboto-Light\";\n                font-size: 17px;\n                font-weight: 300;\n                line-height: 1.5rem;\n                color: #818181;\n            }\n        }\n\n\n        .content_about_usrful {\n            display: flex;\n            flex-direction: row;\n            flex-wrap: nowrap;\n\n            @media screen and (max-width: 991px) {\n                margin: 0 auto;\n                max-width: 720px;\n                flex-direction: column;\n            }\n\n            .about_job_image_usrful {\n                @media screen and (max-width: 991px) {\n                    text-align: center;\n                }\n\n                img {\n                    @media screen and (max-width: 480px) {\n                        width: 100%;\n                        height: auto;\n                    }\n                }\n            }\n\n            .list_reasons {\n                .item_reason {\n                    margin-bottom: 20px;\n                    display: flex;\n                    flex-direction: row;\n                    flex-wrap: nowrap;\n\n                    .num {\n                        display: flex;\n                        justify-content: center;\n                        align-items: center;\n\n                        span {\n                            display: flex;\n                            justify-content: center;\n                            align-items: center;\n                            width: 80px;\n                            height: 80px;\n                            border-radius: 50%;\n                            // padding: 22px;\n                            font-family: \"Roboto-Regular\";\n                            font-size: 1.9rem;\n                            font-weight: 700;\n                        }\n                    }\n\n                    .item_reason_text {\n                        padding: 0 20px;\n                        text-align: left;\n                        font-family: \"Roboto-Light\";\n                        font-size: 17px;\n                        font-weight: 300;\n                        line-height: 1.5rem;\n                        color: #818181;\n\n                        strong {\n                            font-weight: 700;\n                        }\n                    }\n\n                }\n\n                .item_reason:nth-child(odd) {\n                    .num {\n                        span {\n                            background-color: #91b61b;\n                        }\n                    }\n                }\n\n                .item_reason:nth-child(even) {\n                    .num {\n                        span {\n                            background-color: #284722;\n                        }\n                    }\n                }\n            }\n        }\n    }\n}","@keyframes scaleAnimation {\n    0% {\n      opacity: 1;\n    }\n\n    50% {\n      opacity: 0;\n      transform: scale(1.3);\n\n    }\n    70%{\n    transform: scale(1);\n    }\n\n    100% {\n      opacity: 1;\n    }\n  }"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
